import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setCustomerInfo } from 'redux/actions'
import Button from 'components/Button';
import FooterBar from 'components/FooterBar';
import Spinner from 'components/Spinner';
import GeneralGroupNotes from './GeneralGroupNotes';
import BookingInformation from './BookingInformation';
import GuestInformation from 'components/BookingMain/GuestInformation';
import GuestInformationImages from 'components/BookingMain/GuestInformationImages';
import BillOfSale from 'components/BookingMain/BillOfSale';
import { useQuery, useMutation } from '@apollo/client';
import {
  GET_GROUP_DETAILS_BY_GROUP_ID,
  UPDATE_GROUP_BY_GROUP_ID
} from 'graphql/service';
import {
  Content,
  ContentColumn,
  Container,
} from 'components/BookingMain/styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const CafePanel = () => {

  const [groupNotes, setGroupNotes] = useState([])
  const groupId = useParams().groupId

  const { data: groupData, loading, error } = useQuery(GET_GROUP_DETAILS_BY_GROUP_ID, {
    variables: { groupId: groupId },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  })

  const groupByID = groupData?.groupByID;
  const bookings = groupByID?.bookings ?? [];

  useEffect(() => {
    setGroupNotes(groupByID?.groupNotes ?? []);
  }, [groupByID]);
  
  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  if (loading) return <Spinner />;

  const bookingInformationArray = []
  const sortedBookings = [...bookings].sort((a, b) => a.bookingId - b.bookingId)
  sortedBookings.forEach((booking)=> {
    bookingInformationArray.push(      
      <Container
        key={booking.bookingId}
      >
        <BookingInformation
          groupId={groupId}
          booking={booking}
        />
      </Container>      
    )
  })

  return (
    <>
      <Helmet>
        <title>Group Details - Rook Hotel PMS</title>
        <meta name="description" content="Group Details - Rook Hotel PMS" />
      </Helmet>
      <Content>
        <ContentColumn>
          <Container>
            {bookingInformationArray}
          </Container>
        </ContentColumn>
        <ContentColumn>
          <Container>
            <GeneralGroupNotes
              notes={groupNotes}
              setNotes={setGroupNotes}
              groupId={groupId}
              headerString={"GENERAL GROUP NOTES"}
            />
          </Container>
        </ContentColumn>
      </Content>
      <FooterBar />
    </>
  );
}

export default CafePanel;